import sessionService from '@/app-domains/user/session/session.service'
import { API } from './api'

const controlStatusFnct = (res, error) => {
  if (res.status === 401 && !(process.env.TEST_API || process.env.TEST)) {
    window.localStorage.clear()
    window.location.reload()
  } else {
    throw new Error(error)
  }
}

export async function getTLDS () {
  const res = await API.get('onboarding/domains-pricing')
  if (res.status !== 200) controlStatusFnct(res, 'Unexpected status code for GET /onboarding/domains-pricing')
  return res
}

export async function checkDomainAvailability (domain) {
  try {
    const res = await API.get(`onboarding/check-domain?domainName=${domain}`)
    if (res.status !== 200) controlStatusFnct(res, `Unexpected status code for GET /onboarding/check-domain?domainName=${domain}`)
    return res
  } catch (error) {
    return error
  }
}

export async function checkSubDomainAvailability (subdomain) {
  try {
    const res = await API.get(`onboarding/check-subdomain?subdomainName=${subdomain}`)
    if (res.status !== 200) controlStatusFnct(res, 'Unexpected status code for GET /check-subdomain')
    return res
  } catch (error) {
    return error
  }
}

export async function createTrialSubscription (subdomain) {
  try {
    const isSandbox = sessionService.isSandboxSession()
    const res = await API.post('onboarding/trial-subscription', { subdomainName: subdomain, sandbox: isSandbox })
    if (res.status !== 201) controlStatusFnct(res, 'Unexpected status code for POST /onboarding/trial-subscription')
    return res
  } catch (error) {
    return error
  }
}

export async function validateCoupon (coupon) {
  try {
    const res = await API.get(`billing/validate-coupon-code/${coupon}`)
    if (res.status !== 200) controlStatusFnct(res, `Unexpected status code for GET /billing/validate-coupon-code/${coupon}`)
    return res
  } catch (error) {
    return error
  }
}
export async function createSubscription (domainName, couponCode = undefined) {
  try {
    const isSandbox = sessionService.isSandboxSession()
    couponCode = couponCode && couponCode.length !== 0 ? couponCode : undefined
    const res = await API.post('billing/create-subscription', { domainName, couponCode: couponCode, sandbox: isSandbox })
    if (res.status !== 201) controlStatusFnct(res, 'Unexpected status code for POST /billing/create-subscription')
    return res
  } catch (error) {
    return error
  }
}

export async function createBYODSubscription (couponCode = undefined) {
  try {
    const isSandbox = sessionService.isSandboxSession()
    couponCode = couponCode && couponCode.length !== 0 ? couponCode : undefined
    const res = await API.post('billing/create-subscription', { type: 'byod', couponCode: couponCode, sandbox: isSandbox })
    if (res.status !== 201) controlStatusFnct(res, 'Unexpected status code for POST /billing/create-subscription')
    return res
  } catch (error) {
    return error
  }
}
